module.exports = __webpack_public_path__ + "img/result.de02ad03.png";